import React from "react";

const intro = (
  <div>
    <h2>Introduction</h2>
    <p>Put something here that sounds super smart</p>
  </div>
);

export default intro;



// WEBPACK FOOTER //
// ./src/docs/Introduction.js